import { render, staticRenderFns } from "./XRadioGroup.vue?vue&type=template&id=29d3ab2e&scoped=true"
import script from "./XRadioGroup.vue?vue&type=script&lang=js"
export * from "./XRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./XRadioGroup.vue?vue&type=style&index=0&id=29d3ab2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d3ab2e",
  null
  
)

export default component.exports